import wixStores from 'wix-stores';
import wixData from 'wix-data';
import wixWindow from 'wix-window';



let minGift;
let saleActive;
let cartId;
let cartTotal;
let showLightBox;

$w.onReady(async function () {

    await wixData.query('GiftsPremotionParameters')
        .find()
        .then((giftPara) => {
            console.log('giftPara = ', giftPara)
            if (giftPara.items.length > 0) {

                minGift = giftPara.items[0].minTotal;
                saleActive = giftPara.items[0].active;
            }
        })

    wixStores.onCartChanged((cart) => {
         addGift(cart)

    });

})

function addGift(cart) {

    cartId = cart._id;
    cartTotal = cart.totals.total;

    wixData.query('Gifts')
        .eq('cartId', cartId)
        .find()
        .then((gift) => {

            if (gift.items.length > 0)

                showLightBox = gift.items[0].showLightBox

            else {

                let toInsert = {
                    "cartId": cartId,
                    "showLightBox": true,

                };
                wixData.insert("Gifts", toInsert)

                    .catch((err) => {
                        let errorMsg = err;
                    });

                showLightBox = true

            }
        })
        .then(() => {

			console.log ('cartTotal=', cartTotal, ' minGift=', minGift, ' saleActive=', saleActive, ' showLightBox=', showLightBox)

            if (cartTotal > minGift - 1 && saleActive && showLightBox) {

                wixWindow.openLightbox("זכית במתנה" , { 'cartId':cartId });

            }

        })

}